import styled from 'styled-components'
import { Border, Colors, Spacing, Typography } from '../../styles'
import { pointerQuery } from '../../styles/dimensions'

const SelectableContainer = styled.div<{ isSelected: boolean }>`
    background-color: ${({ isSelected }) => (isSelected ? Colors.background.sub : Colors.background.white)};
    border: ${Border.stroke.medium} solid ${({ isSelected }) => (isSelected ? Colors.background.border : 'transparent')};
    border-radius: ${Border.radius.medium};
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    /* See ItemContainer: a stuck :hover after a tap reads as a selected row. */
    ${pointerQuery.canHover} {
        &:hover {
            background-color: ${Colors.background.sub};
            border-color: ${Colors.background.border};
        }
    }
    ${pointerQuery.noHover} {
        &:active {
            background-color: ${Colors.background.sub};
        }
    }
    display: flex;
    align-items: center;
    gap: ${Spacing._8};
    padding: ${Spacing._12} ${Spacing._8} ${Spacing._12} ${Spacing._16};
    margin-bottom: ${Spacing._4};
    ${Typography.body.medium};
`

export const EdgeHighlight = styled.div<{ color: string; squareStart?: boolean; squareEnd?: boolean }>`
    position: absolute;
    left: 0;
    height: 100%;
    width: 4px;
    background-color: ${(props) => props.color};
    border-top-left-radius: ${(props) => (props.squareStart ? '0' : Border.radius.small)};
    border-bottom-left-radius: ${(props) => (props.squareEnd ? '0' : Border.radius.small)};
`
export default SelectableContainer
